export const FETCHING_GALLERY = 'FETCHING_GALLERY';
export const FETCHING_GALLERY_SUCCESS = 'FETCHING_GALLERY_SUCCESS';
export const FETCHING_GALLERY_FAILED = 'FETCHING_GALLERY_FAILED';

export const ADD_GALLERY = 'ADD_GALLERY';
export const ADD_GALLERY_FAILED = 'ADD_GALLERY_FAILED';
export const ADD_GALLERY_SUCCESS = 'ADD_GALLERY_SUCCESS';

export const DELETE_GALLERY = 'DELETE_GALLERY';
export const DELETE_GALLERY_FAILED = 'DELETE_GALLERY_FAILED';
export const DELETE_GALLERY_SUCCESS = 'DELETE_GALLERY_SUCCESS';

export const FETCHING_CATEGORY_GALLERY = 'FETCHING_CATEGORY_GALLERY';
export const FETCHING_CATEGORY_GALLERY_SUCCESS = 'FETCHING_CATEGORY_GALLERY_SUCCESS';
export const FETCHING_CATEGORY_GALLERY_FAILED = 'FETCHING_CATEGORY_GALLERY_FAILED';